<template>
    <div>
        <PageHeaderUI title="Shipment Timeline" breadcrumb="Dashboard > Operations > Shipments" />
        <BookingsTimeLine />
    </div>
</template>

<script>
import BookingsTimeLine from "@/components/3pl/Operations/Bookings/bookingTimeLine.vue";
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
export default {
    components: {
        BookingsTimeLine,
        PageHeaderUI
    },
};
</script>

<style></style>
